import React from 'react';
import { number, string } from 'prop-types';

export default function ResultCount({ count, countLabel }) {
    return (
        <div className="result-count">
            <h4>
                {countLabel} ({count})
            </h4>
        </div>
    );
}

ResultCount.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    count: number.isRequired,
    countLabel: string.isRequired
    /* eslint-enable react/no-typos */
};
